import { render, staticRenderFns } from "./MobileStatusHeader.vue?vue&type=template&id=12f31c34&scoped=true&"
import script from "./MobileStatusHeader.vue?vue&type=script&lang=js&"
export * from "./MobileStatusHeader.vue?vue&type=script&lang=js&"
import style0 from "./MobileStatusHeader.vue?vue&type=style&index=0&id=12f31c34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f31c34",
  null
  
)

export default component.exports